import React from 'react';
import PublicPage from '../cms/PublicPage';

export default function AcademicsPage() {
  return <PublicPage slug="academics" />;
}
